<mat-dialog-content class="mat-typography">
  @for (brand of brandLists; track brand) {
    <p (click)="updateBrandList(brand)">{{brand.brand}}</p>
  }
</mat-dialog-content>
